import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgYearInReviewLogoFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewLogoFull";
import { SvgYearInReviewTextFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewTextFull";
import { UGGLogoFull } from "@ugitgud/legos/ui/icon/UGGLogoFull";
import { SvgArrowPointRight } from "@ugitgud/legos/ui/icon/SVG/ArrowPointRight";

interface PlayerLandingModuleProps {
  userName: string;
  tagLine: string;
  iconId?: number;
  onScrollToModules: () => void;
}

export const PlayerLandingModule: React.FC<PlayerLandingModuleProps> = ({ userName, tagLine, iconId, onScrollToModules }) => {
  const { getProfileIconImg } = getRiotAssetsContext();

  return (
    <section className="flex flex-col space-y-[100px] items-center">
      <div className="flex flex-col items-center space-y-0">
        <img className="w-[85px] h-[85px] rounded-[50px] border-[2px] border-[#F4C874]" src={getProfileIconImg(iconId)} />
        <h1 className="text-center xs:text-[96px] text-[61px] font-medium uppercase leading-normal tracking-normal drop-shadow-[0_2px_2px_rgba(0,0,0,0.40)] font-[Barlow] bg-gradient-to-b from-[#F4C874_25%] to-[#D3A752_84%] bg-clip-text text-transparent">
          {userName}
        </h1>
        <p className="text-white text-center xs:text-[32px] text-[20px] font-normal uppercase leading-normaldrop-shadow-[0_2px_2px_rgba(0,0,0,0.40)] font-[Barlow]">
          #{tagLine}
        </p>
      </div>

      <div className="flex flex-col space-y-[60px] items-center">
        <div className="flex space-x-[24px] justify-center">
          <Icon icon={<SvgYearInReviewLogoFull />} className="xs:w-[156.41px] xs:h-[150px] w-[100px] h-[95px]" />
          <div className="flex flex-col xs:space-y-[25.54px] space-y-[16px]">
            <Icon icon={<SvgYearInReviewTextFull />} className="xs:w-[235.168px] xs:h-[114.397px] w-[150px] h-[73px]" />
            <div className="xs:w-[232px] w-[150px] h-[5.025px] bg-[#D3A752] drop-shadow-[0_2px_2px_rgba(0,0,0,0.25)]  border-0" />
          </div>
        </div>

        {/* --- MODIFIED SECTION: U.GG Logo + Tooltip --- */}
        <div className="flex items-center gap-4 relative">
          <Icon icon={<UGGLogoFull />} className="w-[111px] h-[36px] shrink-0 aspect-[37/12]" />

          {/* Tooltip Group */}
          <div className="group relative cursor-help">
            {/* The 'i' Icon */}
            <div className="w-[18px] h-[18px] rounded-full border border-[#5C5C8E] bg-[#11112A]/50 flex items-center justify-center transition-colors hover:border-[#CDDCFE]">
              <span className="text-[#CDDCFE] text-[10px] font-bold font-['Inter']">i</span>
            </div>

            {/* The Tooltip Popup */}
            <div
              className="absolute xs:left-full xs:top-1/2 ml-3 xs:-translate-y-1/2 xs:translate-x-0 xs:mt-0 xs:ml-3 w-[220px] p-3 rounded-md 
                          bg-[#11112A]/95 border border-[#383864] backdrop-blur-sm
                          opacity-0 invisible group-hover:opacity-100 group-hover:visible 
                          transition-all duration-200 z-50 pointer-events-none
                          top-full left-1/2 -translate-x-1/2 mt-2"
            >
              <p className="text-[#CDDCFE] text-[12px] leading-tight font-['Inter']">
                Due to legacy Riot API issues, data from earlier this year may be missing.
              </p>
            </div>
          </div>
        </div>
        {/* --------------------------------------------- */}
      </div>
      <Icon
        icon={<SvgArrowPointRight />}
        className="w-[36px] h-[36px] rotate-90 shrink-0 aspect-square cursor-pointer"
        onClick={onScrollToModules}
      />
    </section>
  );
};
